// Marker: payment_slip_agent_v1
import React, { useState, useEffect } from 'react';
import API from '../api';

function fmtMoney(n, cur) {
  if (n === null || n === undefined || n === '') return '-';
  var s = Number(n).toLocaleString('th-TH', { minimumFractionDigits: 2 });
  return cur === 'USDT' ? (s + ' USDT') : ('฿' + s);
}

function fmtDateTime(d) {
  if (!d) return '-';
  try { return new Date(d).toLocaleString('th-TH', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); }
  catch (e) { return d; }
}

function statusInfo(st) {
  if (st === 'approved') return { label: '✅ อนุมัติแล้ว', bg: '#dcfce7', fg: '#166534' };
  if (st === 'rejected') return { label: '❌ ไม่ผ่าน', bg: '#fee2e2', fg: '#991b1b' };
  return { label: '🕐 รอตรวจสอบ', bg: '#fef3c7', fg: '#92400e' };
}

export default function SlipReviewModal(props) {
  const invoice = props.invoice;
  const [slips, setSlips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState('');
  const [rejectId, setRejectId] = useState('');
  const [rejectNote, setRejectNote] = useState('');
  const [msg, setMsg] = useState('');

  function load() {
    setLoading(true);
    API.get('/api/invoices/' + invoice.id + '/slips')
      .then(function (r) { setSlips((r.data && r.data.slips) || []); })
      .catch(function () { setMsg('โหลดสลิปไม่สำเร็จ'); })
      .finally(function () { setLoading(false); });
  }

  useEffect(function () { load(); }, [invoice.id]);

  function approve(slipId) {
    if (busy) return;
    setBusy(slipId); setMsg('');
    API.post('/api/invoices/' + invoice.id + '/slips/' + slipId + '/approve', {})
      .then(function () { setMsg('✅ อนุมัติแล้ว — ใบแจ้งหนี้เปลี่ยนเป็นจ่ายแล้ว'); if (props.onClose) props.onClose(true); }) /* slip_reload_v1 */
      .catch(function () { setMsg('อนุมัติไม่สำเร็จ'); })
      .finally(function () { setBusy(''); });
  }

  function doReject(slipId) {
    if (busy) return;
    setBusy(slipId); setMsg('');
    API.post('/api/invoices/' + invoice.id + '/slips/' + slipId + '/reject', { review_note: rejectNote })
      .then(function () { setMsg('ปฏิเสธสลิปแล้ว'); setRejectId(''); setRejectNote(''); load(); })
      .catch(function () { setMsg('ปฏิเสธไม่สำเร็จ'); })
      .finally(function () { setBusy(''); });
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 12, padding: 20, maxWidth: 480, width: '100%', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a' }}>📤 สลิปของ {invoice.invoice_number}</div>
          <button onClick={function () { props.onClose(false); }} style={{ background: '#f1f5f9', border: 'none', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', fontSize: 14 }}>✕</button>
        </div>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 30, color: '#94a3b8' }}>กำลังโหลด...</div>
        ) : slips.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 30, color: '#94a3b8' }}>ยังไม่มีสลิปที่อัพโหลด</div>
        ) : (
          slips.map(function (sp) {
            var si = statusInfo(sp.status);
            return (
              <div key={sp.id} style={{ border: '1px solid #e2e8f0', borderRadius: 10, padding: 12, marginBottom: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <span style={{ background: si.bg, color: si.fg, padding: '2px 10px', borderRadius: 8, fontSize: 12, fontWeight: 600 }}>{si.label}</span>
                  <span style={{ fontSize: 11, color: '#94a3b8' }}>{fmtDateTime(sp.uploaded_at)}</span>
                </div>
                <a href={sp.slip_url} target="_blank" rel="noreferrer">
                  <img src={sp.slip_url} alt="slip" style={{ width: '100%', maxHeight: 280, objectFit: 'contain', borderRadius: 8, background: '#f8fafc', marginBottom: 8 }} />
                </a>
                <div style={{ fontSize: 13, color: '#475569', marginBottom: 8 }}>ยอดที่ลูกค้าแจ้ง: <b>{fmtMoney(sp.uploaded_amount, sp.uploaded_currency)}</b></div>
                {sp.review_note ? <div style={{ fontSize: 12, color: '#991b1b', marginBottom: 8 }}>เหตุผล: {sp.review_note}</div> : null}
                {sp.status === 'pending' ? (
                  rejectId === sp.id ? (
                    <div>
                      <input type="text" placeholder="เหตุผลที่ปฏิเสธ (ไม่บังคับ)" value={rejectNote} onChange={function (e) { setRejectNote(e.target.value); }} style={{ width: '100%', padding: '8px 10px', border: '1px solid #e2e8f0', borderRadius: 8, boxSizing: 'border-box', marginBottom: 8, fontSize: 13 }} />
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button onClick={function () { doReject(sp.id); }} disabled={busy === sp.id} style={{ flex: 1, padding: '10px', background: '#dc2626', color: 'white', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>ยืนยันปฏิเสธ</button>
                        <button onClick={function () { setRejectId(''); setRejectNote(''); }} style={{ flex: 1, padding: '10px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>ยกเลิก</button>
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={function () { approve(sp.id); }} disabled={busy === sp.id} style={{ flex: 1, padding: '10px', background: '#16a34a', color: 'white', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>{busy === sp.id ? '...' : '✅ อนุมัติ'}</button>
                      <button onClick={function () { setRejectId(sp.id); }} style={{ flex: 1, padding: '10px', background: 'white', color: '#dc2626', border: '1px solid #dc2626', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>❌ ปฏิเสธ</button>
                    </div>
                  )
                ) : null}
              </div>
            );
          })
        )}
        {msg ? <div style={{ marginTop: 8, fontSize: 13, color: '#475569', textAlign: 'center' }}>{msg}</div> : null}
      </div>
    </div>
  );
}
